import { SurveyFormatViewProps } from '../types';

/** Type-guard for `children` being a function */
export const isChildFunction = (
  c: SurveyFormatViewProps['children']
): c is (isActive: boolean, setNextActive: () => void) => React.ReactElement => typeof c === 'function';

export default isChildFunction;
